export const moveElemToEnd = (targetArr, ...elIds) => {
    for (const [i, elem] of targetArr.entries()) {
        if (elIds.includes(elem.id)) {
            targetArr.push(targetArr.splice(i, 1)[0]);
        }
    }
    return targetArr;
};